import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetViewKeys = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_VIEW_KEYS
            });

            if (data.status === 'success') {

                dispatch(Action.SetGetViewKeysAction({
                    qiwi_public_key: data.data.public_key,
                    qiwi_secret_key: data.data.secret_key,
                    qiwi_oauth: data.data.oauth,
                    max_amount_for_withdrawals: data.data.max_amount_for_withdrawals,
                    count_withdrawals_of_day: data.data.count_withdrawals_of_day,
                    amountSum: data.amount,
                    wallet: data.data.wallet,
                    wallet_key: data.data.wallet_key
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetViewKeys as SetGetViewKeys
}